var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{staticStyle:{"width":"100%"},attrs:{"options":_vm.options,"disabled":_vm.disabledValue,"size":_vm.size,"props":{ 'value': 'name' ,'label':'name'},"clearable":_vm.clearable,"placeholder":"请选择","filterable":""},on:{"change":_vm.handleChange},model:{value:(_vm.fvalue),callback:function ($$v) {_vm.fvalue=$$v},expression:"fvalue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }